import { useState, useEffect } from 'react';
import { Title } from '../../component/title/Title';
import GridComponent from '../../component/grid/GridComponent.component';
import { getProducts } from './Products.service';
import Form from './form/Form.component';
import Table from '../../component/table/Table.component';
import { Action, ACTION_VIEW } from '../../component/table/interfaces/TableInterface';
import { useSnackbar } from '../../context/Snackbar';
import Product from './interfaces/Product';
import { Pagination } from "../../component/table/interfaces/Pagination";
import { INITIAL_PAGINATION } from '../../component/table/component/pagination/utils/Pagination';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import FormSearch from './form/FormSearchTypeProduct.component';
import FormProduct from './form/FormProduct.component';
import { useProducts } from '../../context/SearchProduct';
import { useStore } from '../../context/Store';
import { BiPurchaseTag } from 'react-icons/bi';

export default function ProductsComponent() {

  let history = useHistory();
  const { setSnackbar } = useSnackbar();
  const { store } = useStore();
  const { searchProducts, setSearchProducts, typeSearch, setTypeSearch, search, setSearch } = useProducts();
  const [products, setProducts] = useState<Product[]>([]);
  const [productsAux, setProductsAux] = useState<Product[]>([]);
  const [request, setRequest] = useState<boolean>(false);
  const [reload, setReload] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
  const [isEAN, setIsEAN] = useState<boolean>(false);

  useEffect(() => {
    setRequest(false);
  }, [request]);

  useEffect(() => {
    if (searchProducts.length) {
      setProducts(searchProducts);
      setProductsAux(searchProducts);
      setIsEAN(typeSearch);
    }
  }, [searchProducts.length, typeSearch, searchProducts]);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleClickAction = (action: Action, product: Product) => {
    if (action === ACTION_VIEW) {
      return history.push(`/produtos/${product.MATNR}-${product.WERKS}-${product.EAN11}`);
    }
  };

  const handleSubmitProducts = async (product: Product) => {
    setReload(true);
    product.DESCMERCA = product.DESCMERCA?.toLocaleUpperCase();
    product.LOJA = [store];
    await getProducts(product).then((res) => {
      const products: Product[] = formatProductMatnr(res.data.ET_RELATORIO);
      setProducts(products);
      setProductsAux(products);
      setSearchProducts(products);
      product.MERCADORIA = String(Number(product.MERCADORIA));
      setSearch(product);
      setRequest(!request);
    }).catch((error) => {
      setSnackbar({ msg: "Erro ao consultar produto!", type: 'error' });
    }).finally(() => {
      setReload(false);
    });
  };

  const formatProductMatnr = (product: Product[]): Product[] => {
    let productsAux: Product[] = product.map((item: Product) => {
      item.MATNR = String(Number(item.MATNR));
      return item;
    });
    return productsAux;
  }

  const handleSubmitProductsType = (value: string) => {
    setIsEAN(!Number(value) ? false : true);
    setTypeSearch(!Number(value) ? false : true);
  };

  const handleSubmitProductsSearch = (productList: Product[]) => {
    let productAux: Product = productList[0];

    const empty: boolean = !productAux.MARCA && !productAux.SETOR && !productAux.SECAO && !productAux.GRUPO && !productAux.SUBGRUPO && !productAux.GRPMERCADORIA && !productAux.VIGENTE && !productAux.REGULAR;

    if (empty) {
      return setProductsAux([...products]);
    }

    let productsAux: Product[] = filter([...products], { ...productAux });
    return setProductsAux(productsAux);
  };

  const filter = (products: Product[], product: Product): Product[] => {
    products = product.MARCA ? products.filter((valueObj: Product) => check(valueObj.MARCA, product.MARCA)) : products;
    products = product.SETOR ? products.filter((valueObj: Product) => check(valueObj.SETOR, product.SETOR)) : products;
    products = product.SECAO ? products.filter((valueObj: Product) => check(valueObj.SECAO, product.SECAO)) : products;
    products = product.GRUPO ? products.filter((valueObj: Product) => check(valueObj.GRUPO, product.GRUPO)) : products;
    products = product.SUBGRUPO ? products.filter((valueObj: Product) => check(valueObj.SUBGRUPO, product.SUBGRUPO)) : products;
    products = product.GRPMERCADORIA ? products.filter((valueObj: Product) => check(valueObj.GRPMERCADORIA, product.GRPMERCADORIA)) : products;
    products = product.VIGENTE ? products.filter((valueObj: Product) => Number(valueObj.VIGENTE) >= Number(product.VIGENTE) && Number(valueObj.VIGENTE) <= Number(product.REGULAR)) : products;
    return products;
  }

  const check = (value: string | undefined, value2: string | undefined): boolean => {
    return value === value2 || Number(value2) === 0;
  }

  const pageSelect = (products: Product[]) => {
    if (pagination.page) {
      return products.slice((pagination.page - 1) * 30, pagination.page * 30)
    }

    return productsAux;
  }

  return (
    <>
      <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Pesquisar Produtos</Title>
      <GridComponent alignItems='flex-start' justify='space-between' spacing={3}>
        <Grid item xs={12} sm={4} md={3} lg={2}>
          <FormSearch initialValues={isEAN ? '1' : '0'} handleSubmitForm={handleSubmitProductsType} />
          <br />
          {((products.length) && !reload) ? <FormProduct initialValues={[...products]} handleSubmitForm={handleSubmitProductsSearch} /> : <></>}
        </Grid>

        <Grid item xs={12} sm={8} md={9} lg={10} >
          <br />
          <Form initialValues={search} handleSubmitForm={handleSubmitProducts} disabled={isEAN} />
          <br />
          <br />
          <Table
            request={reload}
            data={pageSelect(productsAux)}
            size={products.length}
            headCells={HEAD_CELL}
            page={pagination.page}
            onChangePage={handleChangePage}
            noActionDelete
            noActionEdit
            compare={(value: Product, valueB: any, index: number) => {
              if (value.DATA_INI_PROMO && index === 0) {
                return <GridComponent><BiPurchaseTag fontSize={20} style={{ paddingRight: 4 }} />{valueB}</GridComponent>
              }
              if (index === 4 && value.ESTOQUE && Number(value.ESTOQUE) < 1) {
                return 0;
              }
              return valueB;
            }}
            handleClickAction={handleClickAction}
            emptyMessage={store ? `Nenhum Produto encontrado nesta loja.` : ''}
          />
        </Grid>
      </GridComponent>
    </>
  );
}
